import { TFatcaAdditionalInformation } from '~/modules/identification/forms/FatcaAdditionalInformation/types.ts';
import {
  FatcaStatusFFI,
  FatcaStatusNFFE,
  shuwGiinFatcaStatusFFI,
} from '~/modules/identification/forms/FatcaAdditionalInformation/constants/constants.ts';

export const getFatcaAdditionalInformationInitialValues = (
  formData: TFatcaAdditionalInformation,
  fullNameUkr: string,
  fullNameEng: string
) => ({
  usEntityInfo: {
    clientFullName: formData?.usEntityInfo?.clientFullName || fullNameUkr || null,
    clientFullNameEng: formData?.usEntityInfo?.clientFullNameEng || fullNameEng || null,
    tinEin: formData?.usEntityInfo?.tinEin || null,
    fatcaStatus: formData?.usEntityInfo?.fatcaStatus || null,
  },
  foreignFinancialInstitutionInfo: {
    clientFullName: formData?.foreignFinancialInstitutionInfo?.clientFullName || null,
    fatcaStatusFFI: formData?.foreignFinancialInstitutionInfo?.fatcaStatusFFI || null,
    otherFatcaStatusFFI: formData?.foreignFinancialInstitutionInfo?.otherFatcaStatusFFI || null,
    giin: formData?.foreignFinancialInstitutionInfo?.giin || null,
  },
  nffeInfo: {
    fatcaStatusNFFE: formData?.nffeInfo?.fatcaStatusNFFE || null,
    otherFatcaStatusNFFE: formData?.nffeInfo?.otherFatcaStatusNFFE || null,
    substantialUSOwners:
      (formData?.nffeInfo?.substantialUSOwners?.length as number) > 0
        ? formData?.nffeInfo?.substantialUSOwners?.map((sub) => ({
            id: sub?.id || null,
            lastName: sub?.lastName || null,
            firstName: sub?.firstName || null,
            middleName: sub?.middleName || null,
            lastNameEng: sub?.lastNameEng || null,
            firstNameEng: sub?.firstNameEng || null,
            middleNameEng: sub?.middleNameEng || null,
            tin: sub?.tin || null,
            countryEng: sub?.countryEng || null,
            cityEng: sub?.cityEng || null,
          }))
        : [],
  },
});

export const getFatcaLegalResidentValues = (
  values: TFatcaAdditionalInformation,
  isUSTaxResident: boolean,
  isForeignFinancialUnderFATCA: boolean,
  isControllingPersonUSTaxResident: boolean
) => {
  const ffiInfo = values?.foreignFinancialInstitutionInfo;
  const nffeInfo = values?.nffeInfo;
  const fatcaStatusFFI = ffiInfo?.fatcaStatusFFI;
  const fatcaStatusNFFE = nffeInfo?.fatcaStatusNFFE;

  return {
    ...values,
    usEntityInfo: isUSTaxResident ? values?.usEntityInfo : null,
    foreignFinancialInstitutionInfo: isForeignFinancialUnderFATCA
      ? {
          ...ffiInfo,
          otherFatcaStatusFFI:
            fatcaStatusFFI === FatcaStatusFFI.OTHER ? ffiInfo?.otherFatcaStatusFFI : null,
          giin: shuwGiinFatcaStatusFFI.includes(fatcaStatusFFI as FatcaStatusFFI)
            ? ffiInfo?.giin
            : null,
        }
      : null,
    nffeInfo: isControllingPersonUSTaxResident
      ? {
          ...nffeInfo,
          otherFatcaStatusNFFE:
            fatcaStatusNFFE === FatcaStatusNFFE.OTHER ? nffeInfo?.otherFatcaStatusNFFE : null,
          substantialUSOwners:
            fatcaStatusNFFE === FatcaStatusNFFE.PASSIVE_NFFE_WITH_SUBSTANTIAL_US_OWNERS
              ? nffeInfo?.substantialUSOwners
              : null,
        }
      : null,
  };
};
